// dashitem.js
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// title → path 매핑
const PATH_MAP = {
    "전체오더": "/totalreserve?filter=선택검색",
    "배정": "/totalreserve?filter=매칭완료",
    "미배정": "/totalreserve?filter=예약요청",
    "예약취소": "/totalreserve?filter=예약취소",
    "누적 가입자수": "/user",
    "A/S": "/reserve_as",
    "쿠폰발급 수량": "/coupon",
    "전체 정산 내역": "/biling",
    "쿠폰사용수량": "/coupon",
};

function DashBox({ title, data }) {
    const navigate = useNavigate();

    const pagemove = () => {
        const path = PATH_MAP[title];
        if (path) {
            navigate(path);
        }
    };

    return (
        <Card onClick={pagemove}>
            <Title>{title}</Title>
            <DataContainer>
                <Data>{data}</Data>
            </DataContainer>
        </Card>
    )
}

const Card = styled.div`
    background: white;
    border-radius: 20px;
    padding: 30px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.05);
    cursor: pointer;
    transition: all 0.3s ease;
    height: 100%;
    min-height: 200px; /* Restored visual height */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid transparent;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        border-color: #e9ecef;
    }
`;

const Title = styled.h3`
    font-size: 1.1rem;
    color: #868e96;
    margin: 0 0 15px 0;
    font-weight: 600;
    letter-spacing: -0.5px;
`;

const DataContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
`;

const Data = styled.div`
    font-size: 3rem;
    font-weight: 800;
    color: #343a40;
    line-height: 1;
    font-family: 'Roboto', sans-serif; /* Setup for number font if available, fallback ok */
`;

export default DashBox;
